/* eslint-disable no-mixed-operators */
import React, { useState } from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { ApiCallsFactory } from '../factories/APIcalls';
import PropertyAddressFields from './PropertyAddressFields';
import PropertyCoordinatesFields from './PropertyCoordinatesFields';
import Paper from '@material-ui/core/Paper';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import InfoIcon from '@material-ui/icons/Info';
import ButtonDinamyc from './ButtonDinamyc';
import Grid from '@material-ui/core/Grid';
import { useHistory } from 'react-router-dom';
import { LocalPersistence } from '../factories/index';
import { Select, Form, Input, Row, Col } from 'antd';
import { usePersistedStateSessionStorage } from 'src/store/persistedStateSessionStorage';
import { SESSION_KEYS } from '../constants';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexWrap: 'wrap',
    },
    margin: {
      margin: theme.spacing(1),
    },
  })
);

const AddProperty = (props: { setOpen: void | any }) => {
  const classes = useStyles();
  const [error, setError] = useState<boolean>(false);
  const [errorMsg, setErrorMsg] = useState<string>('');
  const [tabValue, setTabValue] = useState<number>(0);
  const [propertyId, setPropertyId] = useState<string>('');
  const [propertyName, setPropertyName] = useState<string>('');
  const [address, setAddress] = useState<string>('');
  const [city, setCity] = useState<string>('');
  const [state, setState] = useState<string>('');
  const [zip, setZip] = useState<string>('');
  const [country, setCounty] = useState<string>('');
  const [longitude, setLongitude] = useState<string>('');
  const [latitude, setLatitude] = useState<string>('');
  const [validateFields, setValidateFields] = useState<boolean>(false);
  const [addValid, setAddvalid] = useState<boolean>(false);
  const [disableSave, setDisableSave] = useState<boolean>(true);
  const { state: filterParams } = usePersistedStateSessionStorage({
    key: SESSION_KEYS.PROPERTY_PARAMS_SESSION,
    defaultValue: {},
  });

  const history = useHistory();

  const handleTabChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setTabValue(newValue);
  };

  const handleClose = () => {
    props.setOpen(false);
  };

  const handleChange = async (event: any, type: string) => {
    if (!addValid) {
      setAddvalid(true);
    }

    let value = '';
    if (event?.target?.value && typeof event?.target?.value === 'string') {
      value = event?.target?.value;
    } else if (event && typeof event === 'string') {
      value = event;
    }

    switch (type) {
      case 'id':
        return setPropertyId(value);
      case 'name':
        return setPropertyName(value);
      case 'address':
        return setAddress(value);
      case 'city':
        return setCity(value);
      case 'state':
        return setState(value);
      case 'country':
        return setCounty(value);
      case 'zip':
        return setZip(value);
      case 'longitude':
        return setLongitude(value);
      case 'latitude':
        return setLatitude(value);
      default:
        return false;
    }
  };

  const createProperty = async () => {
    // getting session data
    const get_session = new LocalPersistence('session');
    const session = await get_session.getSessionPersistence();
    // Update Supplier once the log-in has been integrated
    const supplier = filterParams.selectedSupplier;
    const body = {
      supplier: supplier,
      propertyId: propertyId.length <= 0 ? null : propertyId,
      propertyName: propertyName.length <= 0 ? null : propertyName,
      address: address.length <= 0 ? null : address,
      city: city.length <= 0 ? null : city,
      state: state.length <= 0 ? null : state,
      country: country.length <= 0 ? null : country,
      zip: zip.length <= 0 ? null : zip,
      latitude: latitude.length <= 0 ? null : latitude,
      longitude: longitude.length <= 0 ? null : longitude,
    };
    try {
      // post
      const addNewProperty = new ApiCallsFactory(
        '/property',
        session.token,
        body
      );
      await addNewProperty.postData();
      // setting up the property id on the session storage
      const persistingPropertyId = new LocalPersistence('session', {
        ...session,
        propertyId,
        propertyName,
        supplier,
      });
      await persistingPropertyId.setSessionPersistence();
      // redirect to details page
      return history.push(`/detailPage`);
    } catch (error: any) {
      const errorMsg = 'Something were wrong, please try again';
      setErrorMsg(errorMsg);
      setError(true);
    }
  };

  const validate = () => {
    useForm
      .validateFields()
      .then((r) => {
        setDisableSave(false);
      })
      .catch((e) => {
        setDisableSave(e?.errorFields.length > 0);
      });
  };

  const [useForm] = Form.useForm();

  return (
    <>
      <div className="p-3">
        <div
          className={error ? 'alert alert-error alert-with-icon m-0' : 'd-none'}
        >
          <em className="dsicon alert-icon dsicon-close-circle-sd"></em>
          <div className="alert-message">{errorMsg}</div>
        </div>
        <Form
          layout="vertical"
          form={useForm}
          name="basic"
          fields={[
            {
              name: ['propertyid'],
              value: propertyId,
            },
            {
              name: ['propertyName'],
              value: propertyName,
            },
            {
              name: ['city'],
              value: city,
            },
            {
              name: ['state'],
              value: state,
            },
            {
              name: ['country'],
              value: country,
            },
            {
              name: ['zip'],
              value: zip,
            },
            {
              name: ['address'],
              value: address,
            },
          ]}
          onValuesChange={validate}
        >
          <Row gutter={24}>
            <Col span={12}>
              <Form.Item
                label="Property ID"
                name="propertyid"
                rules={[
                  {
                    required: true,
                    message: 'Please enter Property ID',
                  },
                ]}
              >
                <Input onChange={(e) => setPropertyId(e?.target?.value)} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="Property Name"
                name="propertyName"
                rules={[
                  {
                    required: true,
                    message: 'Please enter Property Name',
                  },
                ]}
              >
                <Input onChange={(e) => setPropertyName(e?.target?.value)} />
              </Form.Item>
            </Col>
            <Col
              span={24}
              className="alert alert-info mt-3"
              role="alert"
            >
              <InfoIcon className="icon-info" /> Add your property location by
              entering an address or property coordinates
            </Col>
            <Paper
              square
              className="noShadow"
            >
              <Tabs
                value={tabValue}
                onChange={handleTabChange}
                aria-label="tabs"
                className="lightBlueDS"
              >
                <Tab
                  label="Property Address"
                  className="addProperty-tabs"
                />
                <Tab
                  label="Property Coordinates"
                  className="addProperty-tabs"
                />
              </Tabs>
            </Paper>
            {tabValue === 0 && (
              <PropertyAddressFields
                address={address}
                city={city}
                state={state}
                zip={zip}
                setCity={setCity}
                setState={setState}
                setZip={setZip}
                setAddress={setAddress}
                country={country}
                setCountry={setCounty}
                classes={classes}
                handleChange={handleChange}
                validateFields={validateFields}
                longitude={longitude}
                latitude={latitude}
                tabValue={tabValue}
                useForm={useForm}
                validate={validate}
              />
            )}
            {tabValue === 1 && (
              <PropertyCoordinatesFields
                handleChange={handleChange}
                validateFields={validateFields}
                longitude={longitude}
                latitude={latitude}
                address={address}
                tabValue={tabValue}
                useForm={useForm}
                validate={validate}
              />
            )}
            <Grid
              container
              spacing={0}
              className="containerSpacing pt-5"
              justify="center"
            >
              <ButtonDinamyc
                message="Add Property"
                classes={true ? 'blue-btn mx-3' : 'blue-btn mx-3 btn_disabled'}
                action={() => createProperty()}
                disable={disableSave}
              />
              <ButtonDinamyc
                message="Cancel"
                classes="white-btn mx-3"
                action={() => handleClose()}
              />
            </Grid>
          </Row>
        </Form>
      </div>
    </>
  );
};

export default AddProperty;
